// src/extenders/product-details-switcher.js
var ProductDetails = class extends HTMLElement {
  constructor() {
    super();
    const productDetails = this;
    const detailTitles = productDetails.querySelectorAll(".details-title");
    const detailsContent = productDetails.querySelectorAll(".detail-content");
    const readMoreButton = document.querySelector("#read-more-product-description");
    readMoreButton.addEventListener("click", () => {
      detailTitles.forEach((titleElement) => {
        titleElement.classList.remove("active-details-title");
        if (titleElement.dataset.title === "description") {
          titleElement.classList.add("active-details-title");
        }
      });
      detailsContent.forEach((contentElement) => {
        contentElement.classList.remove("active-details-content");
        if (contentElement.dataset.content === "description") {
          contentElement.classList.add("active-details-content");
        }
      });
    });
    detailTitles.forEach((titleElement) => {
      titleElement.addEventListener("click", () => {
        detailTitles.forEach((titleElement2) => {
          titleElement2.classList.remove("active-details-title");
        });
        detailsContent.forEach((contentElement) => {
          contentElement.classList.remove("active-details-content");
          if (titleElement.dataset.title === contentElement.dataset.content) {
            contentElement.classList.add("active-details-content");
            titleElement.classList.add("active-details-title");
          }
        });
      });
    });
  }
};
if (customElements.get("product-details") === void 0) {
  customElements.define("product-details", ProductDetails);
}
